import { NativeSelectProps } from "@material-ui/core/NativeSelect";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import React, { useEffect, useState } from "react";
import NativeSelect from "@material-ui/core/NativeSelect";
import styled from "styled-components";

import { StyledGrid } from "components/simple";

const StyledSelectNarrow = styled(NativeSelect)`
  && {
    padding-left: 0px;
    padding-right: 5px;
    padding-bottom: 0px;
    select {
      padding: 0.5rem 2rem 0.5rem 1rem;
    }
    &:before,
    &:after {
      border-bottom-width: 0px !important;
    }
  }
`;

interface CustomProps {
  callback?: React.Dispatch<string | number>;
  defaultText: string;
  disabled?: boolean;
  options: Record<string, number>[];
  selectedValue?: string;
}

type CycleSelectProps = CustomProps & NativeSelectProps;

const CycleSelect: React.FC<CycleSelectProps> = ({
  callback,
  defaultText,
  disabled = false,
  options,
  selectedValue = "",
  ...otherProps
}: CycleSelectProps) => {
  const [value, setValue] = useState<string>(selectedValue);

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>): void => {
    const value = event.target.value;

    setValue(value);

    if (callback) {
      callback(value);
    }
  };

  return (
    <StyledGrid container alignItems={"center"}>
      <StyledSelectNarrow
        disabled={disabled}
        IconComponent={ArrowDropDownIcon}
        value={value}
        variant="outlined"
        onChange={handleChange}
        {...otherProps}
      >
        <option value={""} disabled>
          {defaultText}
        </option>
        {options.map((option: Record<string, number>) => {
          const keyString = Object.keys(option)[0];
          const valueNumber = option[keyString];
          return (
            <option key={valueNumber} value={valueNumber}>
              {keyString}
            </option>
          );
        })}
      </StyledSelectNarrow>
    </StyledGrid>
  );
};

export default CycleSelect;
